import React from 'react'
import { InputNumber } from 'antd'
import styled from 'styled-components'

import { ChevronDown, ChevronUp } from './DesignSystem/Icons'
import Tooltip from './DesignSystem/Tooltip'
import LabelText from './LabelText'

const Counter = ({
  id,
  className,
  value,
  onChange,
  min,
  max,
  labelText,
  disabled,
  readOnly,
  popup,
}) => {
  const Input = (
    <InputNumber
      id={id}
      min={min}
      max={max}
      value={value}
      onChange={onChange}
      disabled={disabled}
      readOnly={readOnly}
      controls={{
        upIcon: (
          <ChevronUp
            fill={disabled ? '#AAABB8' : '#565B6D'}
            hoverFill="#fff"
            width="17px"
            height="17px"
            className="arrow-icon"
          />
        ),
        downIcon: (
          <ChevronDown
            fill={disabled ? '#AAABB8' : '#565B6D'}
            hoverFill={disabled ? '#AAABB8' : '#fff'}
            width="17px"
            height="17px"
            className="arrow-icon"
          />
        ),
      }}
    />
  )
  return (
    <div className={className}>
      {labelText && <LabelText text={labelText} disabled={disabled} readOnly={readOnly} />}
      {popup && !readOnly ? (
        <Tooltip
          overlayStyle={{
            maxWidth: '250px',
            whiteSpace: 'normal',
          }}
          text={popup.text}
        >
          <div>{Input}</div>
        </Tooltip>
      ) : (
        Input
      )}
    </div>
  )
}

export default styled(Counter)`
  width: 90px;

  .ant-input-number {
    width: 90px;
    height: 36px;
    border-radius: 4px;
    box-shadow: none;
    border: 1px solid ${({ theme }) => theme.ds_gray_6};
    color: ${({ theme }) => theme.ds_gray_1};

    &-out-of-range {
      input {
        color: ${({ theme }) => theme.ds_gray_1}; 
      }
    }

    &-focused, &:hover {
      border: 1px solid #2E41EA;
      border-color: #2E41EA;
    }

    &-disabled {
      background: #fff;
      pointer-events: none;
      border: 1px solid ${({ theme }) => theme.ds_gray_7};
      overflow: hidden;
      color: ${({ theme }) => theme.ds_gray_5};

      .ant-input-number-handler-wrap {
        display: block;
        top: 1px;

        .ant-input-number-handler {
          .ant-input-number-handler-up-inner,
          .ant-input-number-handler-down-inner {
            svg,
            svg > path  {
              fill: ${({ theme }) => theme.ds_gray_5};
            }
          }
        }
      }
    }

    &-readonly {
      pointer-events: none;
    }
  }

  .ant-input-number-input {
    height: 34px;
  }

  .arrow-icon {
    width: 100%;
    display: flex;
    align-items;
    justify-content: center;
  }

  .ant-input-number:hover:not(.ant-input-number-borderless)
  .ant-input-number-handler-down,
  .ant-input-number-focused:not(.ant-input-number-borderless)
  .ant-input-number-handler-down {
    border: none;
  }

  .ant-input-number-handler-wrap {
    opacity: 1;
    width: 33px;
    border-radius: 0 4px 4px 0;
    display: block;

    &:hover {
      .ant-input-number-handler {
        height: 50%;
      }
    }

    .ant-input-number-handler {
      .ant-input-number-handler-up-inner,
      .ant-input-number-handler-down-inner {
        margin: 0;
        width: 33px;
        height: 17px;
        right: 0;

        svg,
        svg > path  {
          fill: ${({ theme }) => theme.ds_gray_2};
        }

        &:hover {
          svg,
          svg > path  {
            fill: #fff;
          }
        }
      }
    }

    .ant-input-number-handler-up {
      border-start-end-radius: 3px;
    }

    .ant-input-number-handler-down {
      border-end-end-radius: 3px;
    }

    .ant-input-number-handler-up-inner {
      top: 0;
    }

    .ant-input-number-handler-down-inner {
      top: 8px;
    }

    .ant-input-number-handler-up,
    .ant-input-number-handler-down {
      border: none;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 50%;

      &:hover {
        height: 50% !important;
        background: #1D2CB3;
      }
    }
  }
`
